import React from "react"

type ModalContentContextType = {
  isModalContent: boolean
}

export const ModalContentContext = React.createContext<ModalContentContextType>(null)
